// extracted by mini-css-extract-plugin
export default {"form":"AddScriptForm_form__4MG1A","field":"AddScriptForm_field__ql1CF","name":"AddScriptForm_name__kaBqb","info":"AddScriptForm_info__JxzsF"};